const validationRegEx = /(^\d{5}$)|(^\d{5}-\d{4}$)/

export function postalCodeInputIsValid(input: string) {
  return validationRegEx.test(input)
}
